<template>
    <div id="app" class="">
        <!-- 路由渲染 -->
        <router-view :key="this.$store.state.key" v-wechat-title="$route.meta.title"></router-view>
    </div>
</template>

<style lang="scss">
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #333;
        background-color: #f5f5f5;
        position: relative;
        overflow-x: hidden;
        min-height: 100vh;
        width: 100vw;
    }
    #YSF-BTN-HOLDER{
        display: none !important;
    }
</style>
<script>
    import api from '@/utils/js/api.js'
    import qs from 'qs';

    export default {
        data(){
            return {
                
            }
        },
        created(){
            // localStorage.removeItem('userInfo');
            // localStorage.removeItem('token');
            console.log('app-created',this.$route.path);
            //判断是否微信打开
            this.is_wx();
            //获取userInfo
            this.$store.commit({type: 'getUserInfo',must: true});
            // 设置baseUrl
            this.setBaseUrl();
            //vuex保存数据
            this.saveVuex(); 
            //静默登录
//             if(window.location.search){
//                 var search = qs.parse(window.location.search.substring(1));
//                 if(this.$store.state.loginPath.indexOf(search.target) == -1) this.wechat_login();
//             }else{
//                 this.wechat_login();
//             }
            

        },
        beforeMount(){
 
        },
        mounted(){
           
        },
        beforeUpdate(){
            //更新导航栏状态
            this.setArrow();
        },
        updated(){

        },
        methods: {
            //vuex保存数据
            saveVuex(){
                //在页面加载时读取sessionStorage里的状态信息
                if(sessionStorage.getItem("userMsg")){
                    var obj = JSON.parse(sessionStorage.getItem("userMsg"));
                    console.log(obj.unload_url == location.href);
                    if(obj.unload_url == location.href){
                        this.$store.replaceState(Object.assign(this.$store.state, obj));
                    }
                    sessionStorage.removeItem("userMsg");
                }
                
                //在页面刷新时将vuex里的信息保存到sessionStorage里
                window.addEventListener("beforeunload",()=>{
                    console.log('刷新页面')
                    this.$store.commit({
                        type: 'comment',
                        name: 'unload_url',
                        unload_url: location.href
                    })
                    sessionStorage.setItem("userMsg",JSON.stringify(this.$store.state))
                })
            },
            //baseUrl
            setBaseUrl(){
                this.$store.commit({
                    type: 'comment',
                    name: 'api',
                    api: {
                        imgUrl: api.imgUrl
                    }
                })
            },
            //导航栏返回
            setArrow(){
                let arr = ['','/','/product_center','/index', '/my']
                if(!arr.includes(this.$route.path)){
                    this.$store.commit({
                        type: 'comment',
                        name: 'leftArrow',
                        leftArrow: true
                    })
                }else{
                    this.$store.commit({
                        type: 'comment',
                        name: 'leftArrow',
                        leftArrow: false
                    })
                }
            },
            //判断是否微信打开
            is_wx(){
                var ua = navigator.userAgent.toLowerCase();
            　　var isWeixin = ua.indexOf('micromessenger') != -1;
            　　if (isWeixin) {
                    console.log('微信');
                    this.$store.commit({
                        type: 'comment',
                        name: 'is_wx',
                        is_wx: true
                    })
                    // this.wechat_login();
            　　}else{
                    console.log('不是微信')
            　　}
            },
            //静默登录获取code
            wechat_login(){
                if(this.$store.state.openid) return;
                if(localStorage.getItem('get_openid') == '1') return localStorage.removeItem('get_openid');
                if(this.$store.state.userInfo && this.$store.state.userInfo.openid) return;
                if(window.location.pathname == '/h5/login') return;
                if(window.location.pathname == '/h5/alipay') return;
                if(window.location.pathname == '/h5/alipay/alipay_success') return;
                if(window.location.search.indexOf('code')>-1){
                    console.log('app-code');
                    var code = qs.parse(window.location.search.substring(1))['code'];
                    this.get_openid(qs.parse(window.location.search.substring(1))['code']);
                }else{
                    console.log('app-no-code');
                    var data = {
                        appid: api.appId,
                        // redirect_uri: encodeURI('http://www.pantaoys.com/h5/index?a=3'),
                        redirect_uri: encodeURI(window.location.href),
                        response_type: 'code',
                        scope: 'snsapi_base',
                        state: (new Date()).valueOf(),
                    }
                    // localStorage.setItem('get_openid', '1');
                    // alert('准备静默登录，data：' + JSON.stringify(data));
                    location.href = api.wechat_auth + `?${qs.stringify(data)}#wechat_redirect`;
                }
                
            },
            //获取openid
            get_openid(code){
                // alert('code:' + code);
                this.$http({
                    url: api.queryWeChatOpenId,
                    method: 'post',
                    data: {
                        code: code,
                    }
                }).then(res=>{
                    // alert(JSON.stringify(res.data));
                    if(res.success){
                        localStorage.setItem('openid',res.data);
                    }
                }).catch(error=>{
                    // alert(JSON.stringify(error));
                })
            },
            // 存userInfo
            save_userInfo(){
                var token = localStorage.getItem('token');
                var userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
                if(token && userInfo){
                    this.$store.commit({
                        type: 'getUserInfo',
                        must: true
                    })
                }
            },
            
        },


    }
</script>
